import { render } from "./WithdrawalView.vue?vue&type=template&id=224ff424"
import script from "./withdrawal-view-component.ts?vue&type=script&lang=js&external"
export * from "./withdrawal-view-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__